module.exports = __webpack_public_path__ + "media/images/logo_mobile-2f105b3397632875463656e773ddd3bb.svg";